import React, { Component } from 'react';
import { Button, MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import PropTypes from 'prop-types';

export default class StringSelect extends Component {

    render() {
        return (
            <>
                <Select items={this.props.items} className="bp3-fill"
                    itemRenderer={(item, { handleClick, index, modifiers, query}) => {
                        return <MenuItem
                            active={modifiers.active}
                            disabled={modifiers.disabled}
                            text={item}
                            onClick={handleClick}
                            key={index}
                        />}}
                    onItemSelect={val => this.props.onChange(val)}
                    popoverProps={{minimal: true}}
                    filterable={false}
                    activeItem={this.props.initial}
                >
                    <Button rightIcon="caret-down" alignText="left" text={this.props.initial} className="bp3-fill" />
                </Select>
            </>
        )
    };
}
  
StringSelect.propTypes = {
    initial: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func,
};

StringSelect.defaultProps = {
    initial: "none",
    items: ["none"],
    onChange: () => {},
};
